import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Backdrop, Typography, Button, Slide } from "@material-ui/core";

import styles from "./styles.styles";
import {
  openModalNotificacion,
  openModalDatos,
} from "../../redux/actions/modalActions";
import { modalNotificacionStatus } from "../../redux/selectors";

export default () => {
  const classes = styles();
  const dispatch = useDispatch();

  const modalStatus = useSelector((state) => modalNotificacionStatus(state));

  const handleClose = () => {
    dispatch(
      openModalNotificacion({ open: false, currDesc: modalStatus.currDesc })
    );
    if (modalStatus.missingData) dispatch(openModalDatos(true));
  };

  return (
    <Modal
      open={modalStatus.open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Slide direction="down" in={modalStatus.open} mountOnEnter unmountOnExit>
        <div className={classes.modalBody}>
          <Typography
            id="transition-modal-title"
            className={classes.modalTitle}
          >
            {modalStatus.currDesc}
          </Typography>
          <div id="modal-description" className={classes.modalForm}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleClose();
              }}
            >
              Ok
            </Button>
          </div>
        </div>
      </Slide>
    </Modal>
  );
};
